<template>
    <div v-if="!item.meta || !item.meta.hidden">
        <el-menu-item v-if="!alwaysShowRootMenu && theOnlyOneChild && !theOnlyOneChild.children" :index="theOnlyOneChild.path">
            {{ theOnlyOneChild.meta.title }}
        </el-menu-item>
        <el-sub-menu v-else :index="item.path">
            <template #title>{{ item.meta.title }}</template>
            <SidebarItem v-for="child in item.children" :key="child.path" :item="child" />
        </el-sub-menu>
    </div>
</template>

<script>
export default {
    name: "SidebarItem",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        alwaysShowRootMenu() {
            return this.item.alwaysShow;
        },
        theOnlyOneChild() {
            if (this.item.children && this.item.children.length === 1) {
                return this.item.children[0];
            }
            return null;
        },
    },
};
</script>